import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Iconify from 'src/components/iconify';
import { STATUS_CONFIG } from 'src/constants/transactionStatus';

export const getStatusInfo = (status) => {
  const config = STATUS_CONFIG[status];

  if (!config) {
    return {
      color: 'default',
      icon: <Iconify icon="mdi:clock-outline" width={18} height={18} />,
      label: status ?? 'Unknown',
    };
  }

  return {
    color: config.color,
    icon: <Iconify icon={config.icon} width={18} height={18} />,
    label: config.label,
    spinner: config.spinner ?? false,
  };
};

function StatusBadge({ status, size }) {
  const { color, icon, label } = getStatusInfo(status);

  return (
    <Chip
      icon={icon}
      label={<Typography variant={size === 'sm' ? 'caption' : 'body2'}>{label}</Typography>}
      color={color}
      size={size === 'sm' ? 'small' : 'medium'}
      variant="soft"
      sx={{
        fontWeight: 500,
        pl: 0.5,
        pr: 1,
        borderRadius: 2,
      }}
    />
  );
}

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['sm', 'md']),
};

export default StatusBadge;
